import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {
  EntityCrudPageTemplateComponent
} from '../../../layout/entity-crud-page-template/entity-crud-page-template.component';
import {DataTableColumnButton, TableColumn, TableLazyEvent} from '../../../shared/contracts/table-column.interface';
import {Tenant} from '../../../tenants/contracts/tenant.interface';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TenantService} from '../../../tenants/services/tenant.service';
import {NotificationService} from '../../../shared/services/notification.service';
import {TenantSettingsService} from '../../../tenants/services/tenant_settings.service';
import {TenantDialogComponent} from '../../../tenants/features/dialogs/tenant-dialog/tenant-dialog.component';
import {filter, finalize, switchMap, take} from 'rxjs';
import {DialogAction} from '../../../shared/contracts/dialog.interface';
import {ConfirmDialogComponent} from '../../../shared/components/dialog/confirm-dialog/confirm-dialog.component';
import {Template} from '../../contracts/template.interface';
import {TemplateService} from '../../services/template.service';
import {TemplateDialogComponent} from '../dialogs/template-dialog/template-dialog.component';
@Component({
  selector: 'app-templates-list',
  standalone: true,
  imports: [
    EntityCrudPageTemplateComponent,
  ],
  templateUrl: './templates-list.component.html',
  styleUrl: './templates-list.component.scss',
  providers: [DialogService, NotificationService]
})
export class TemplatesListComponent implements OnInit, AfterViewInit {

  columns: TableColumn[] = [];

  templates: Template[] = [];
  totalRecords = 0;
  rows = 10;
  loading = false;
  private lastLazyEvent: TableLazyEvent | undefined;

  _refDeleteTemplatesDialog: DynamicDialogRef | undefined;
  _refCreateUpdateTemplatesDialog: DynamicDialogRef | undefined;
  _refSettingsTemplatesDialog: DynamicDialogRef | undefined;

  constructor(
    private templateService: TemplateService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.prepareColumns();
    this.cd.detectChanges();
  }

  saveTemplate(): void {
    this._refCreateUpdateTemplatesDialog = this.dialogService.open(TemplateDialogComponent, {
      ...TemplateDialogComponent.DIALOG_CONFIG,
    });

    this._refCreateUpdateTemplatesDialog.onClose
      .pipe(
        filter((result) => result?.action === DialogAction.OK),
        switchMap(result =>  this.templateService.create(result.data))
      ).subscribe((result) => {
      this.loadTemplates(this.lastLazyEvent!);
      this.notificationService.success("Template creato con successo.");
    });
  }

  editTemplate(template: Template): void {
    this._refCreateUpdateTemplatesDialog = this.dialogService.open(TemplateDialogComponent, {
      ...TemplateDialogComponent.DIALOG_CONFIG,
      data: template,
    });

    this._refCreateUpdateTemplatesDialog.onClose
      .pipe(
        filter((result) => result?.action === DialogAction.OK),
        switchMap(result => this.templateService.update(template.id!, result.data))
      ).subscribe(_ => {
      this.loadTemplates(this.lastLazyEvent!);
      this.notificationService.success("Template modificato con successo.");
    });
  }

  deleteTemplate(template: Template): void {
    this._refDeleteTemplatesDialog = this.dialogService.open(ConfirmDialogComponent, {
      ...ConfirmDialogComponent.DIALOG_CONFIG,
      data: {message: `Sei sicuro di voler eliminare il template ${template.id}`},
    });

    this._refDeleteTemplatesDialog.onClose
      .pipe(
        filter((result) => result?.action === DialogAction.OK),
        switchMap(_ => this.templateService.delete(template.id!)),
      ).subscribe((_) => {
      this.loadTemplates(this.lastLazyEvent!);
      this.notificationService.success("Template eliminato con successo.");
    });
  }

  deleteSelectedTemplates(templates: Template[]): void {
    this.openDeleteTemplatesDialog(templates)
  }

  private openDeleteTemplatesDialog(templates: Template[]): void {
    this._refDeleteTemplatesDialog = this.dialogService.open(ConfirmDialogComponent, {
      ...ConfirmDialogComponent.DIALOG_CONFIG,
      data: {message: `Sei sicuro di voler eliminare ${templates.length} templates?`,}
    });

    this._refDeleteTemplatesDialog.onClose
      .pipe(
        filter((result) => result?.action === DialogAction.OK),
      ).subscribe((_) => {});
  }

  loadTemplates(event: TableLazyEvent): void {
    this.lastLazyEvent = event;
    this.loading = true;
    this.templateService.getAll(event.page, event.rows, event.filters).pipe(
      take(1),
      finalize(() => this.loading = false)
    ).subscribe(data => {
      this.templates = data.data;
      this.totalRecords = data.total;
    });
  }

  prepareColumns(){
    this.columns = [
      { field: 'text', header: 'Testo', sortable: false },
      { header: 'Azioni', buttons: <DataTableColumnButton[]>[
          {icon: 'pi-pencil', click: this.editTemplate.bind(this), tooltip: 'Modifica', color: 'primary' },
          {icon: 'pi-trash', click: this.deleteTemplate.bind(this), tooltip: 'Elimina', color: 'danger' },
        ]}
    ];
  }

}
